import { del, getAuthenticatedRequestConfig } from '../client'

export const removeNotiticationsByIdResource = (params = {}) => {
  const { id } = params

  return del(`/v1/notifications/${id}`, params)
    .then((response) => response)
    .catch((error) => Promise.reject(error))
}

export const removeAuthencatedNotiticationsByIdResource = (
  baseURL,
  authToken,
  authHeader,
  authScheme,
  params = {}
) => {
  const requestConfig = getAuthenticatedRequestConfig(
    baseURL,
    authToken,
    authHeader,
    authScheme,
    params
  )

  return removeNotiticationsByIdResource(requestConfig)
}

export default removeNotiticationsByIdResource
